export const ASSET_RECLASS_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  CANCELLED: "CANCELLED",
} as const;
export type AssetReclassStatus =
  (typeof ASSET_RECLASS_STATUS)[keyof typeof ASSET_RECLASS_STATUS];
